import React, { useEffect, useState } from "react";
import ApiClient from "../../methods/api/apiClient";
import { useHistory } from "react-router-dom";
import loader from "../../methods/loader";
import Pagination from "react-pagination-js";
import { useSelector } from "react-redux";
import Layout2 from "../../components/global/layout2";

const statusOptions = [
  { value: "", label: "All Statuses" },
  { value: "sent", label: "Sent" },
  { value: "failed", label: "Failed" },
  { value: "pending", label: "Pending" },
];

const EmailLogs = () => {
  const [data, setdata] = useState([]);
  const history = useHistory();
  const [total, setTotal] = useState(0);
  const [loaderr, setLoaderr] = useState(false);

  const user = useSelector((state) => state.user);
  const searchState = useSelector((state) => state.search);

  const [filters, setFilter] = useState({
    page: 1,
    count: 20,
    search: "",
    status: "",
    template_id: "",
    recipient: "",
  });

  const ChangeFilter = (e) => {
    setFilter(e);
    Getdata(e);
  };

  const pageChange = (e) => {
    setFilter({ ...filters, page: e });
    Getdata({ page: e });
  };

  const Getdata = (p = {}) => {
    loader(true);
    setLoaderr(true);
    let filter = { ...filters, ...p };
    // Remove empty filter values
    let params = {};
    Object.keys(filter).forEach((key) => {
      if (filter[key] !== "" && filter[key] !== undefined) {
        params[key] = filter[key];
      }
    });
    ApiClient.get("email-logs", params).then((res) => {
      if (res.success) {
        setdata(res?.data?.data || res?.data || []);
        setTotal(res?.data?.total_count || res?.data?.total || 0);
      }
      loader(false);
      setLoaderr(false);
    });
  };

  useEffect(() => {
    Getdata();
  }, []);

  useEffect(() => {
    if (user && user.loggedIn) {
      setFilter({ ...filters, recipient: searchState.data });
      Getdata({ recipient: searchState.data, page: 1 });
    }
  }, [searchState]);

  const handleRecipientSearch = (e) => {
    const val = e.target.value;
    setFilter({ ...filters, recipient: val, page: 1 });
    clearTimeout(window._emailLogSearchTimeout);
    window._emailLogSearchTimeout = setTimeout(() => {
      Getdata({ recipient: val, page: 1 });
    }, 400);
  };

  const getStatusBadge = (status) => {
    const styles = {
      sent: {
        bg: "#e6f7ee",
        color: "#389e6b",
        icon: "check_circle",
      },
      failed: {
        bg: "#fff1f0",
        color: "#cf1322",
        icon: "error",
      },
      pending: {
        bg: "#fff7e6",
        color: "#d48806",
        icon: "schedule",
      },
    };
    const style = styles[status] || styles.pending;
    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "4px",
          padding: "4px 12px",
          borderRadius: "12px",
          fontSize: "12px",
          fontWeight: 500,
          backgroundColor: style.bg,
          color: style.color,
          textTransform: "capitalize",
        }}
      >
        <i
          className="material-icons"
          style={{ fontSize: "14px" }}
        >
          {style.icon}
        </i>
        {status || "pending"}
      </span>
    );
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <Layout2 title="Email Logs" Sidetitle="Email Logs">
      <div className="mainareas new-table-set">
        {/* Header */}
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
          <div className="bids-top mb-2 mb-sm-0">
            <h4>
              Results<span>{total}</span>
            </h4>
          </div>
        </div>

        {/* Filters */}
        <div className="d-flex flex-wrap gap-3 mb-3">
          <div style={{ minWidth: "220px", flex: 1, maxWidth: "350px" }}>
            <input
              type="text"
              className="form-control"
              placeholder="Search by recipient email..."
              value={filters.recipient}
              onChange={handleRecipientSearch}
            />
          </div>
          <div>
            <select
              className="form-control"
              value={filters.status}
              onChange={(e) => {
                const val = e.target.value;
                setFilter({ ...filters, status: val, page: 1 });
                Getdata({ status: val, page: 1 });
              }}
            >
              {statusOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Table */}
        <div className="table-responsive table_section new-table">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Template Name</th>
                <th scope="col">Recipient</th>
                <th scope="col">Subject</th>
                <th scope="col">Status</th>
                <th scope="col">Sent At</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((itm, index) => (
                <tr key={itm.id || itm._id || index}>
                  <td>
                    <div className="user_detail">
                      <div className="user_name">
                        <h4
                          className="user"
                          style={{ cursor: "default" }}
                        >
                          {itm.template_name ||
                            itm.templateName ||
                            itm.template?.name ||
                            "-"}
                        </h4>
                      </div>
                    </div>
                  </td>
                  <td>{itm.recipient || itm.to || "-"}</td>
                  <td>
                    {(itm.subject || "-")?.length > 50
                      ? itm.subject.substr(0, 50) + "..."
                      : itm.subject || "-"}
                  </td>
                  <td>{getStatusBadge(itm.status)}</td>
                  <td>
                    {formatDate(
                      itm.sent_at || itm.sentAt || itm.createdAt || itm.created_at
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Empty State */}
        {total === 0 && !loaderr ? (
          <div className="no-data">
            <img src="assets/img/no-data.png" alt="No data" />
            No Email Logs Found
          </div>
        ) : null}

        {/* Pagination */}
        {total > 0 ? (
          <div className="paginationWrapper gap-0">
            <div className="d-flex align-items-center mb-2 mb-sm-0">
              <div className="me-2 user-name-color">Show</div>
              {total > 0 && (
                <div className="dropdown addDropdown chnagesname">
                  <button
                    className="btn btn-primary dropdown-toggle removeBg"
                    type="button"
                    id="dropdownMenuButton"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    {filters?.count}
                  </button>
                  <div
                    className="dropdown-menu shadow bg_hover"
                    aria-labelledby="dropdownMenuButton"
                  >
                    {[10, 20, 30, 50].map((n) => (
                      <a
                        key={n}
                        className="dropdown-item"
                        onClick={() =>
                          ChangeFilter({ ...filters, count: n, page: 1 })
                        }
                      >
                        {n}
                      </a>
                    ))}
                  </div>
                </div>
              )}
              <div className="ms-2 user-name-color">from {total} Logs</div>
            </div>
            <Pagination
              currentPage={filters.page}
              totalSize={total}
              sizePerPage={filters.count}
              changeCurrentPage={pageChange}
            />
          </div>
        ) : null}
      </div>
    </Layout2>
  );
};

export default EmailLogs;
